import { SupportedIde, SupportedIdeType } from "TFS/VersionControl/Contracts";
import { CallbackHub } from "VersionControl/Scenarios/Shared/CallbackHub";

export interface ChangeSelectedIdePayload {
    selectedIde: SupportedIde;
    isSelectedIdeVisualStudio: boolean;
}

export interface SetSupportedIdesPayload {
    ides: SupportedIde[];
    favoriteIdeType: SupportedIdeType;
    isFavoriteIdeVisualStudio: boolean;
}

export interface PatTokenDataPayload {
    patUsername: string;
    patPassword: string;
}

export class ActionsHub {
    public createFilesRequested = new CallbackHub<void>();
    public createFilesCompleted = new CallbackHub<string>();
    public setSupportedIdes = new CallbackHub<SetSupportedIdesPayload>();
    public changeSelectedIde = new CallbackHub<ChangeSelectedIdePayload>();
    public toggleButtonClicked = new CallbackHub<string>();
    public waitingOnServerStarted = new CallbackHub<void>();
    public patTokenDataUpdated = new CallbackHub<PatTokenDataPayload>();
    public gitCredentialsErrorOccurred = new CallbackHub<string>();
    public gitCredentialsErrorRemoved = new CallbackHub<void>();
    public generateGitCredentialsButtonClicked = new CallbackHub<void>();
    public gitContributePermissionUpdated = new CallbackHub<boolean>();
}
